(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k2a-bottle-cooler-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-k2a-bottle-product]');

    sections.forEach((section) => {
      const picker = section.querySelector('[data-variant-picker]');
      const records = Array.from(section.querySelectorAll('[data-variant-record]')).map((element) => ({
        element,
        id: element.dataset.id,
        title: element.dataset.title,
        sku: element.dataset.sku,
        options: JSON.parse(element.dataset.options || '[]'),
        price: element.dataset.price,
        priceIncludingVat: element.dataset.priceIncludingVat,
        compareAt: element.dataset.compareAt,
        available: element.dataset.available === 'true',
        mediaUrl: element.dataset.mediaUrl,
        mediaSrcset: element.dataset.mediaSrcset,
        mediaAlt: element.dataset.mediaAlt
      }));

      if (!picker || records.length === 0) return;

      const getSelectedOptions = () => Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
        const selected = fieldset.querySelector('[data-option-input]:checked');
        return selected ? selected.value : '';
      });

      const getSelectedLabels = () => Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
        const selected = fieldset.querySelector('[data-option-input]:checked');
        if (!selected) return '';
        const label = picker.querySelector(`label[for="${CSS.escape(selected.id)}"] strong`);
        return label ? label.textContent.trim() : selected.value;
      });

      const findVariant = (options) => records.find((record) => record.options.every((value, index) => value === options[index]));

      const updateOptionPrices = (selectedOptions) => {
        picker.querySelectorAll('fieldset').forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('[data-option-input]').forEach((input) => {
            const candidateOptions = [...selectedOptions];
            candidateOptions[optionIndex] = input.value;
            const candidate = findVariant(candidateOptions);
            const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            const price = label ? label.querySelector('[data-option-price]') : null;

            input.disabled = !candidate;
            if (price) price.textContent = candidate ? candidate.price : '';
          });
        });
      };

      const updateVariant = () => {
        const selectedOptions = getSelectedOptions();
        const variant = findVariant(selectedOptions);
        if (!variant) return;

        const currentPrice = section.querySelector('[data-current-price]');
        const currentPriceIncludingVat = section.querySelector('[data-current-price-including-vat]');
        const currentCompareAt = section.querySelector('[data-current-compare-at]');
        const selectedVariant = section.querySelector('[data-selected-variant]');
        const selectedSku = section.querySelector('[data-selected-sku]');
        const cartVariantId = section.querySelector('[data-cart-variant-id]');
        const quoteSku = section.querySelector('[data-quote-sku]');
        const quoteVariant = section.querySelector('[data-quote-variant]');
        const productImage = section.querySelector('.k2a-bottle-product__media img');

        if (currentPrice) currentPrice.textContent = variant.price;
        if (currentPriceIncludingVat) currentPriceIncludingVat.textContent = variant.priceIncludingVat;
        if (currentCompareAt) {
          currentCompareAt.textContent = variant.compareAt;
          currentCompareAt.hidden = !variant.compareAt;
        }
        if (selectedVariant) selectedVariant.textContent = getSelectedLabels().join(' / ');
        if (selectedSku) selectedSku.textContent = variant.sku;
        if (cartVariantId) cartVariantId.value = variant.id;
        if (quoteSku) quoteSku.value = variant.sku;
        if (quoteVariant) quoteVariant.value = variant.title;
        if (productImage && variant.mediaUrl) {
          productImage.src = variant.mediaUrl;
          productImage.srcset = variant.mediaSrcset;
          productImage.alt = variant.mediaAlt;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id.replace('gid://shopify/ProductVariant/', ''));
        window.history.replaceState({}, '', url);
        updateOptionPrices(selectedOptions);
      };

      picker.addEventListener('change', updateVariant);
      updateVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
